export const PROTOCOL_ERROR_MESSAGE = 'Erro ao buscar o histórico de atendimentos.'
